import React from 'react';

class F_1 extends React.Component {
    constructor(props) {
        super(props);

        this.gotoNextStep = this.gotoNextStep.bind(this);
    }

    gotoNextStep(e) {
        e.preventDefault();

        if(e.target.dataset['view'] === 'offer') {
            this.props.saveValues({login_type: 'offer'});
        }
        this.props.nextStep(e.target.dataset['next']);
    }

    render() {
        return (
            <div className="click2call--groups">
                <div className="click2call--group click2call--group-label">
                    <p>W jakiej sprawie chcesz się skontaktować z doradcą?</p>
                </div>
                <div className="click2call--group">
                    <div className="click2call--content-choice">
                        <button id={`hash${Math.random()}`} onClick={this.gotoNextStep} data-next="F_2">Obsługa</button>
                        <button id={`hash${Math.random()}`} onClick={this.gotoNextStep} data-next="F_4" data-view="offer">Przedłużenie/nowa umowa</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default F_1;